import PropTypes from 'prop-types';

const data = PropTypes.shape({
  percentage: PropTypes.number,
});

export const IProgressBarProps = {
  data,
};
